import { createSlice } from '@reduxjs/toolkit';
import { getDefaultReportTemplateApi } from '../../../rtk-apis/reports/getDefaultReportTemplate';

const initialState = {
  status: '',
  result: '' as any,
  msg: '',
  loading: false,
};

const getDefaultReportTemplateSlice = createSlice({
  name: 'getDefaultReportTemplate',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getDefaultReportTemplateApi.pending, state => {
        state.loading = true;
      })
      .addCase(getDefaultReportTemplateApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.msg = action?.payload?.msg;
        state.result = action?.payload;
      })
      .addCase(getDefaultReportTemplateApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = action?.payload as string;
        state.result = (action?.payload as string) || '';
      });
  },
});

export const { clearState } = getDefaultReportTemplateSlice.actions;
export default getDefaultReportTemplateSlice.reducer;
